module.exports = __webpack_public_path__ + "static/media/codeInLogo.fee92c18.png";